import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import NextLink from 'next/link';
import { Schema, SchemaProps } from '@keaze/web/components/schema';
import { Actions } from '../actions';

export const Header = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
    flex-direction: column;
    margin-bottom: 20px;

    ${breakpoints.up('md')} {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 35px;
    }
  `}
`;

export const Address = styled(Typography)`
  margin-right: 10px;
  display: inline-block;
  opacity: 0.75;
  ${({ theme: { colors } }) => `
color: ${colors.greens.green0};
`}
`;

export const Schemes = styled(Box)`
  ${({ theme: { breakpoints } }) => `
     display: none;

    ${breakpoints.up('md')} {
      display: flex;
      justify-content: end;
    }
  `}
`;

export const MobileSchemes = styled(Box)`
  ${({ theme: { breakpoints } }) => `
    display: flex;


    ${breakpoints.up('md')} {
      display: none;
    }
  `}
`;

export const StyledSchema = styled(Schema)<SchemaProps>`
  margin-right: 1px;

  &:last-child {
    margin-right: 0;
  }
`;

export const Statuses = styled(Box)`
  display: inline-flex;

  & > * {
    margin-right: 3px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const SchemesWrapper = styled(Box)`
  ${({ theme: { breakpoints } }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    ${breakpoints.up('md')} {
      display: block;
      margin-top: 0;
    }
  `}
`;

export const MobileMapButton = styled(Button)`
  ${({ theme: { palette, breakpoints } }) => `
    color: ${palette.primary.main};
    font-weight: 500;
    background-color: transparent;

    &.MuiButton-containedSizeSmall {
      padding: 3px;
    }

    ${breakpoints.up('md')} {
      display: none;
    }
  `}
`;

export const Title = styled(Typography)`
  ${({ theme: { colors } }) => `
color: ${colors.greens.green0};
`}
`;

export const TitleWrapper = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
  
    ${Title} {
      ${breakpoints.up('md')} {
        margin-right: 20px;
      }
    }
  `}
`;

export const StyledActions = styled(Actions)`
  ${({ theme: { breakpoints } }) => `
     display: none;
  
    ${breakpoints.up('md')} {
      display: flex;
    }
  `}
`;

export const ArrowLeftBlock = styled.div`
  ${({ theme: { breakpoints } }) => `
            position: relative;
            left: -2rem;
            top: 0.9rem;
        ${breakpoints.up('md')} {
            
        }
    `}
`;
